<template>
  <div class="icon-gen">
    <div class="gen-layout">
      <div class="gen-preview">
        <div class="preview-wrapper">
          <canvas ref="canvas" width="256" height="256" />
        </div>
        <div class="download-row">
          <span v-for="s in sizes" :key="s" class="dl-chip" @click="downloadSize(s)">{{ s }}<small>px</small></span>
        </div>
      </div>

      <div class="gen-controls">
        <div class="ctrl-block">
          <label>{{ $t('tool.IconGenerator.text') }}</label>
          <el-input v-model="text" maxlength="3" :placeholder="$t('tool.IconGenerator.text')" size="small" @input="draw" class="text-input" />
        </div>

        <div class="ctrl-block">
          <label>{{ $t('tool.IconGenerator.shape') }}</label>
          <div class="shape-row">
            <div v-for="sh in shapeList" :key="sh.key" class="shape-opt" :class="{ on: shape === sh.key }" @click="shape = sh.key; draw()">
              <svg width="28" height="28" viewBox="0 0 28 28"><path :d="sh.path" fill="currentColor" fill-opacity=".35" /></svg>
              <span>{{ sh.label }}</span>
            </div>
          </div>
        </div>

        <div class="ctrl-block">
          <label>{{ $t('tool.IconGenerator.bgColor') }}</label>
          <div class="palette-row">
            <span v-for="p in palettes" :key="p.bg" class="palette-dot"
              :style="{ background: p.bg }"
              :class="{ on: bgColor === p.bg && textColor === p.fg }"
              @click="bgColor = p.bg; textColor = p.fg; draw()" />
            <el-color-picker v-model="bgColor" size="small" @change="draw" class="custom-pick" />
          </div>
        </div>

        <div class="ctrl-block">
          <label>字号</label>
          <el-slider v-model="fontSize" :min="60" :max="160" :step="10" @change="draw" />
        </div>

        <div class="ctrl-block" v-if="shape === 'rounded'">
          <label>圆角</label>
          <el-slider v-model="borderRadius" :min="0" :max="128" :step="4" @change="draw" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconGeneratorTool',
  props: { config: { type: Object, default: () => ({}) } },
  data: () => ({
    shape: 'rounded', bgColor: '#4e7cff', text: 'A',
    textColor: '#FFFFFF', fontSize: 110, borderRadius: 40,
    dataUrl: '', sizes: [16, 32, 64, 128],
    palettes: [
      { bg: '#4e7cff', fg: '#FFFFFF' },
      { bg: '#67c23a', fg: '#FFFFFF' },
      { bg: '#e6a23c', fg: '#FFFFFF' },
      { bg: '#f56c6c', fg: '#FFFFFF' },
      { bg: '#303133', fg: '#FFFFFF' },
      { bg: '#f0f2f5', fg: '#303133' },
      { bg: '#ffffff', fg: '#4e7cff' },
      { bg: 'linear-gradient(135deg,#667eea,#764ba2)', fg: '#FFFFFF' }
    ],
    shapes: [
      { key: 'rounded', path: 'M4 0h20a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z' },
      { key: 'circle', path: 'M14 28a14 14 0 1 1 0-28 14 14 0 0 1 0 28z' },
      { key: 'square', path: 'M0 0h28v28H0z' },
      { key: 'diamond', path: 'M14 1l13 13-13 13L1 14z' }
    ]
  }),
  computed: {
    shapeLabels() { var t=this; return { rounded:t.$t('tool.IconGenerator.shapeRounded'), circle:t.$t('tool.IconGenerator.shapeCircle'), square:t.$t('tool.IconGenerator.shapeSquare'), diamond:t.$t('tool.IconGenerator.shapeDiamond') } },
    shapeList() { var t=this; return this.shapes.map(function(s){ return {key:s.key,path:s.path,label:t.shapeLabels[s.key]} }) }
  },
  mounted() { this.$nextTick(() => this.draw()) },
  methods: {
    draw() {
      const c = this.$refs.canvas; if (!c) return
      const ctx = c.getContext('2d')
      ctx.clearRect(0, 0, 256, 256)
      ctx.fillStyle = this.bgColor
      if (this.shape === 'circle') {
        ctx.beginPath(); ctx.arc(128, 128, 126, 0, Math.PI * 2); ctx.fill()
      } else if (this.shape === 'diamond') {
        ctx.beginPath(); ctx.moveTo(128, 4); ctx.lineTo(252, 128); ctx.lineTo(128, 252); ctx.lineTo(4, 128); ctx.fill()
      } else {
        const r = this.shape === 'rounded' ? this.borderRadius : 0
        ctx.beginPath(); ctx.moveTo(r, 4)
        ctx.lineTo(252 - r, 4); ctx.quadraticCurveTo(252, 4, 252, 4 + r)
        ctx.lineTo(252, 252 - r); ctx.quadraticCurveTo(252, 252, 252 - r, 252)
        ctx.lineTo(r, 252); ctx.quadraticCurveTo(4, 252, 4, 252 - r)
        ctx.lineTo(4, 4 + r); ctx.quadraticCurveTo(4, 4, r, 4)
        ctx.fill()
      }
      if (this.text) {
        ctx.fillStyle = this.textColor
        ctx.font = `bold ${this.fontSize}px -apple-system,"Microsoft YaHei",sans-serif`
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle'
        ctx.fillText(this.text.slice(0, 3), 128, 130)
      }
      this.dataUrl = c.toDataURL('image/png')
    },
    downloadSize(s) {
      const c2 = document.createElement('canvas'); c2.width = s; c2.height = s
      const ctx = c2.getContext('2d')
      const img = new Image(); img.src = this.dataUrl
      img.onload = () => { ctx.drawImage(img, 0, 0, s, s); const a = document.createElement('a'); document.body.appendChild(a); a.href = c2.toDataURL(); a.download = `icon-${s}.png`; a.click(); document.body.removeChild(a) }
    },
    doAction(a) { if (a === 'clear') { this.text = 'A'; this.bgColor = '#4e7cff'; this.textColor = '#FFFFFF'; this.shape = 'rounded'; this.fontSize = 110; this.borderRadius = 40; this.draw() } }
  }
}
</script>

<style scoped>
.icon-gen { max-width: 600px; margin: 0 auto; }
.gen-layout { display: flex; gap: 32px; align-items: flex-start; }

.gen-preview { flex-shrink: 0; text-align: center; }
.preview-wrapper {
  width: 180px; height: 180px; margin: 0 auto 16px;
  background: repeating-conic-gradient(#f0f0f0 0% 25%,#fff 0% 50%) 50%/16px 16px;
  border-radius: 16px; overflow: hidden;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
}
.preview-wrapper canvas { width: 100%; height: 100%; display: block; }

.download-row { display: flex; gap: 6px; justify-content: center; }
.dl-chip {
  font-size: 13px; font-weight: 600; color: #4e7cff; background: #f0f4ff;
  padding: 4px 10px; border-radius: 6px; cursor: pointer; transition: all .15s;
  display: flex; align-items: baseline; gap: 1px;
}
.dl-chip small { font-size: 10px; font-weight: 400; }
.dl-chip:hover { background: #4e7cff; color: #fff; }

.gen-controls { flex: 1; display: flex; flex-direction: column; gap: 16px; }
.ctrl-block { }
.ctrl-block label {
  font-size: 12px; font-weight: 600; color: #8892a6;
  text-transform: uppercase; letter-spacing: 1px; display: block; margin-bottom: 8px;
}

.text-input { width: 140px; }

.shape-row { display: flex; gap: 4px; }
.shape-opt {
  display: flex; align-items: center; gap: 4px;
  padding: 4px 10px 4px 6px; border-radius: 6px; cursor: pointer;
  border: 1px solid #e4e7ed; color: #8892a6; font-size: 12px; transition: all .15s;
}
.shape-opt:hover { border-color: #4e7cff; color: #4e7cff; }
.shape-opt.on { border-color: #4e7cff; color: #4e7cff; background: #f0f4ff; }

.palette-row { display: flex; gap: 6px; align-items: center; flex-wrap: wrap; }
.palette-dot {
  width: 26px; height: 26px; border-radius: 50%; cursor: pointer;
  border: 2px solid #e4e7ed; transition: all .15s;
}
.palette-dot:hover { transform: scale(1.15); border-color: #909399; }
.palette-dot.on { border-color: #4e7cff; box-shadow: 0 0 0 2px rgba(78,124,255,.25); }
.custom-pick { margin-left: 4px; }

.ctrl-block ::v-deep .el-slider { margin: 0 4px; }
.ctrl-block ::v-deep .el-slider__runway { margin: 6px 0; }

@media (max-width: 560px) {
  .gen-layout { flex-direction: column; align-items: center; }
  .gen-controls { width: 100%; }
}
</style>
